import type { Translation } from '../types.ts';
import type en from '../en/backups.ts';

export default {
    card: {
        title: 'Back-ups',
        intro: 'Een back-up bundelt de databaserijen en mediabestanden van deze website. Dagelijkse back-ups lopen automatisch; gebruik de knop voor een momentopname op afroep.',
        create: 'Back-up maken',
        empty: 'Nog geen back-ups.',
        columns: {
            kind: 'Soort',
            size: 'Grootte',
        },
        confirmDelete: 'Verwijderen?',
        restore: 'Terugzetten',
        deleteBackup: 'Back-up verwijderen',
    },
    kind: {
        manual: 'handmatig',
        scheduled: 'gepland',
        preRestore: 'voor terugzetten',
        imported: 'geïmporteerd',
        final: 'bij verwijderen',
    },
    lastRestore: {
        title: 'Laatst teruggezet',
        detail: 'de back-up van {from}, gestart {when} door {who}',
        goneBackup: 'een back-up die niet meer in de lijst staat',
    },
    status: {
        queued: 'in wachtrij',
        running: 'bezig',
        success: 'gelukt',
        failed: 'mislukt',
    },
    restoreDialog: {
        title: 'Deze back-up terugzetten?',
        body: 'Dit vervangt de {current} van de website door de inhoud van de back-up van {age}. De huidige gegevens worden overschreven. Eerst wordt {safety}, dus dit kan ongedaan worden gemaakt.',
        current: 'huidige databaserijen en mediabestanden',
        safety: 'automatisch een veiligheidsback-up gemaakt',
    },
} satisfies Translation<typeof en>;
